module.exports = __webpack_public_path__ + "media/Video 12.6fc05de1.mp4";